import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import DashboardService from "../../services/DashboardService";

export const fetchDashboard = createAsyncThunk(
  "dashboard/fetchDashboard",
  async (data) => {
    try {
      const res = await DashboardService.getDashboard(data);
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchBranchDashboard = createAsyncThunk(
  "dashboard/fetchBranchDashboard",
  async () => {
    try {
      const res = await DashboardService.getBranchDashboard();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

const initialState = {
  loading: false,
  error: "",
  dashboard: null,
};

const dahsboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers(builder) {
    // Get Merchant Dashboard
    builder
      .addCase(fetchDashboard.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDashboard.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.dashboard = payload.data;
      })
      .addCase(fetchDashboard.rejected, (state) => {
        state.loading = false;
      });

    // Get Branch Dashboard

    builder
      .addCase(fetchBranchDashboard.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBranchDashboard.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.dashboard = payload.data;
      })
      .addCase(fetchBranchDashboard.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default dahsboardSlice.reducer;
